"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseImpactStatus = exports.CaseStatusStage = exports.CaseStatus = void 0;
const __1 = require("..");
var CaseStatus;
(function (CaseStatus) {
    CaseStatus["NEW"] = "New";
    CaseStatus["IN_PROGRESS"] = "InProgress";
    CaseStatus["DUPLICATED"] = "Duplicated";
    CaseStatus["FALSE_POSITIVE"] = "FalsePositive";
    CaseStatus["INDETERMINATE"] = "Indeterminate";
    CaseStatus["OTHER"] = "Other";
    CaseStatus["TRUE_POSITIVE"] = "TruePositive";
})(CaseStatus = exports.CaseStatus || (exports.CaseStatus = {}));
var CaseStatusStage;
(function (CaseStatusStage) {
    CaseStatusStage["NEW"] = "New";
    CaseStatusStage["IN_PROGRESS"] = "InProgress";
    CaseStatusStage["CLOSED"] = "Closed";
})(CaseStatusStage = exports.CaseStatusStage || (exports.CaseStatusStage = {}));
var CaseImpactStatus;
(function (CaseImpactStatus) {
    CaseImpactStatus["NO_IMPACT"] = "NoImpact";
    CaseImpactStatus["WITH_IMPACT"] = "WithImpact";
    CaseImpactStatus["NOT_APPLICABLE"] = "NotApplicable";
})(CaseImpactStatus = exports.CaseImpactStatus || (exports.CaseImpactStatus = {}));
